export default {
  "Content-Type": "application/json",
  "X-HSBC-Channel-Id": "WEB",
  "X-HSBC-Chnl-CountryCode": "GB",
  "X-HSBC-Chnl-Group-Member": "MSRF",
  "X-HSBC-Locale": "en_GB"
};
